module.exports = __webpack_public_path__ + "static/media/solta_white.3f16664b.svg";